import { render, staticRenderFns } from "./changeApproval.vue?vue&type=template&id=defc6a2a&scoped=true&"
import script from "./changeApproval.vue?vue&type=script&lang=js&"
export * from "./changeApproval.vue?vue&type=script&lang=js&"
import style0 from "./changeApproval.vue?vue&type=style&index=0&id=defc6a2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defc6a2a",
  null
  
)

export default component.exports